var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXimKreis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.22 37.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f61;opacity:1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_1",
    className: "cls-1",
    d: "M5.45,31.77c-1.76-1.76-3.15-3.85-4.09-6.16C.46,23.39,0,21.01,0,18.61c0-2.4,.46-4.78,1.36-7,.93-2.31,2.32-4.4,4.09-6.16,1.76-1.76,3.85-3.15,6.16-4.09C13.83,.46,16.21,0,18.61,0c2.4,0,4.78,.46,7,1.36,2.31,.93,4.4,2.32,6.16,4.09,1.76,1.76,3.15,3.85,4.09,6.16,.9,2.22,1.37,4.6,1.36,7,0,2.4-.46,4.78-1.36,7-.93,2.31-2.32,4.4-4.09,6.16-1.76,1.76-3.85,3.15-6.16,4.09-2.22,.9-4.6,1.37-7,1.36-2.4,0-4.78-.46-7-1.36-2.31-.93-4.4-2.32-6.16-4.09Zm11.65-13.16l-5.29,5.29,1.51,1.51,5.29-5.29,5.29,5.29,1.51-1.51-5.29-5.29,5.29-5.29-1.51-1.51-5.29,5.29-5.29-5.29-1.51,1.51,5.29,5.29Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXimKreis);
export default __webpack_public_path__ + "static/media/X im Kreis.8f7ee3a216bc55a581c34bdb8bb2c00a.svg";
export { ForwardRef as ReactComponent };